import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../utility/local-storage.service';
import { PivcApiServices } from '../services/pivc-api.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-pivc-complete',
  templateUrl: './pivc-complete.component.html',
  styleUrls: ['./pivc-complete.component.scss']
})
export class PivcCompleteComponent implements OnInit {
  public answerList = LocalStorageService.get('answerList')
  ? LocalStorageService.get('answerList')
  : '';
  public contentDetails: any | object = LocalStorageService.get('contentDetails')
    ? LocalStorageService.get('contentDetails')
    : '';
    public submitBtnHidden = true;
  public apiResponseStorage: any | object = LocalStorageService.get('apiResponseStorage')
    ? LocalStorageService.get('apiResponseStorage')
    : '';
  public policyNumber: string;

  constructor(public restApi: PivcApiServices, public router: Router) { }

  /*
  * Initial Hook
  */
  ngOnInit() {
    if (typeof this.contentDetails === 'object' && 'policyNumber' in this.contentDetails) {
      this.policyNumber = this.contentDetails.policyNumber;
    }
  }

}
